// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__9OeuP","range":"MonthRangeSwitch_range__1HSHW","disabled":"MonthRangeSwitch_disabled__2wJjY"};